<template>
  <v-list>
    <field-item
      v-for="field in fields"
      :key="field.id"
      :field="field"
      @edit="$emit('edit-field', field)"
    />
  </v-list>
</template>

<script>
import FieldItem from './FieldItem.vue';

export default {
  name: 'FieldList',
  components: {
    FieldItem
  },
  props: {
    fields: {
      type: Array,
      required: true
    }
  }
}
</script>
